var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"mx-1"},[_c('v-col',{attrs:{"cols":"7"}},[_c('PemetaanGolongan',{on:{"on-select":_vm.handleSelect}})],1),_c('v-col',{attrs:{"cols":"5"}},[_c('DaftarPendidikan',{ref:"daftarPendidikan"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }